module.exports = __webpack_public_path__ + "img/movimiento_poliza.eb0d8100.png";